module.exports = __webpack_public_path__ + "static/media/plate2Img4.9d450cd4.png";